/* eslint-disable max-len */
import React, { useMemo } from 'react';
import styled from 'styled-components';
import { useObserver } from '../../../CodesThatsGottaGoSomewhereElse';
import { Component, ObjectManager } from '../../../concepts/objects';
import { Fill } from '../../../ui/Fill';
import { useResolve } from '../../Container';
import { useEditorSessionObserver } from '../../canvas/EditorSession';
import { ComponentMount } from '../../canvas/visualization/ComponentMount';
import { RenderBox } from '../../canvas/visualization/RenderHelpers';
import { HandInfo } from './HandInfo';
import { HandLayout } from './HandLayout';
import { HoldLayout, HoldLayoutItem } from './HoldLayout';

const HoldItemFrame = styled.div<{ speed: string }>`
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none !important;
    
    & * {
        pointer-events: none !important;
    }

    transition: transform ${p => p.speed === 'fast' ? '0ms' : '400ms'} cubic-bezier(0.22, 1, 0.36, 1);
`;

const HoldItemMount = React.memo<{ object: Component, item: HoldLayoutItem }>(({ object, item }) => {
    return <HoldItemFrame speed={item.transition} style={{ transform: item.transform.toCSS(), zIndex: item.order }}>
        <ComponentMount object={object} />
    </HoldItemFrame>;
});

const RenderHold = React.memo(() => {
    const objects = useResolve(ObjectManager);
    const layout = useObserver(useResolve(HoldLayout));

    // Order by id to prevent animation flicker
    const sorted = useMemo(() => layout.slice().sort((a, b) => a.id.localeCompare(b.id)), [layout]);

    return <>
        {sorted.map(item =>
            <HoldItemMount key={item.id} object={objects.get(item.id)} item={item} />
        )}
    </>;
});

const RenderConsole = React.memo(() => {

    const { frame, path } = useObserver(useResolve(HandLayout));

    // return <svg width={frame.width} height={frame.height} opacity={0.5}>
    //     <defs>
    //         <filter id="s" colorInterpolationFilters="sRGB">
    //             <feDropShadow dx="0" dy="-1" stdDeviation="5" floodOpacity="0.2" />
    //         </filter>
    //         <radialGradient id="f" cx=".5" cy=".1" r="1">
    //             <stop stopColor={Colors.slate200} />
    //             <stop offset="1" stopColor={Colors.slate400} />
    //         </radialGradient>
    //     </defs>
    //     <path d={path.toString()} fill="url(#f)" stroke={Colors.slate400} filter="url(#s)" strokeWidth="2" />
    // </svg>;

    const style = {
        position: 'absolute',
        top: '100%',
        left: '50%',
        width: 750,
        height: 124,
        transform: 'translate(-50%, -50%)',
        background: '#F4F4F4',
        boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.25)',
        borderRadius: '50%',
    };

    return <RenderBox {...style}>

    </RenderBox>;
});

export const HandLayer = () => {

    const { enabled } = useEditorSessionObserver(HandInfo);
    if (!enabled) return null;

    return <Fill id="hand-layer" overflow="hidden" pointerEvents="none" zIndex="1">
        <RenderConsole />
        <RenderHold />
    </Fill>;
};
